
import { NgModule } from '@angular/core';

import { AccommodationEditProvider } from './accommodation-edit.provider';
import { AccommodationListProvider } from './accommodation-list.provider';

export * from './accommodation-edit.provider';
export * from './accommodation-list.provider';

export {
  AccommodationListProvider,
  AccommodationEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    AccommodationEditProvider,
    AccommodationListProvider
  ]
})
export class AccommodationBackendModule { }
